import React from 'react';
import './SelectBankView.less';
import NavigationBar from '../../../../components/NavigationBar/NavigationBar';
import { isDashboardScreen } from '../../../../../utils';
import {
  isLocalizeAdded,
  LocalizePropType,
  maskSepa,
} from 'getaway-data-layer';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import CardItem from '../../../../components/CardItem/CardItem';

type Props = {
  localize: LocalizePropType;
  isSelectingBanks: boolean;
  truelayerAccounts: any[];
  onSelectAccount: (arg: any) => void;
  onClose: () => void;
  onPressBankSelection: () => void;
  onPressManual: () => void;
};

const SelectBankView = ({
  localize,
  isSelectingBanks,
  truelayerAccounts,
  onSelectAccount,
  onClose,
  onPressBankSelection,
  onPressManual,
}: Props) => {
  return (
    <div className="screen-container">
      <NavigationBar
        TitleTestId="SelectBankView-title"
        title={localize('bank.select.title')}
        description={localize('bank.select.desr')}
        onClose={onClose}
        showHelp
        showArrowBack={isDashboardScreen() || isSelectingBanks}
      />
      <div
        className={
          isLocalizeAdded(localize, 'select.bank.faq')
            ? 'screen-body-faq'
            : 'screen-body'
        }
      >
        <div
          className={
            isLocalizeAdded(localize, 'select.bank.faq')
              ? 'screen-body-content-faq'
              : 'screen-body-content'
          }
        >
          {isSelectingBanks ? (
            <>
              {truelayerAccounts?.map((account, index) => (
                <CardItem
                  data-testid="CardItem-account"
                  key={`account-${index}`}
                  localize={localize}
                  title={account?.display_name}
                  description={`${localize('iban')} ${
                    account?.account_number?.iban
                      ? maskSepa(account?.account_number?.iban)
                      : ''
                  }`}
                  selected={false}
                  hideRadio
                  firstItem={index === 0}
                  lastItem={index === truelayerAccounts.length - 1}
                  icon="/images/bank.png"
                  onClick={() => onSelectAccount(account)}
                />
              ))}
            </>
          ) : (
            <>
              <CardItem
                testid="selectBank"
                localize={localize}
                title={localize('select.bank.card.title')}
                description={localize('select.bank.card.desc')}
                selected={false}
                hideRadio
                firstItem
                icon="/images/bank.png"
                onClick={onPressBankSelection}
                bankCheckHeaderImg="/images/bankCheckHeader.png"
              />
              <CardItem
                testid="SelectBankView-enterIban"
                localize={localize}
                title={localize('select.bank.manual.title')}
                description={localize('select.bank.manual.desc')}
                selected={false}
                hideRadio
                lastItem
                icon="/images/bank.png"
                onClick={onPressManual}
              />
              <div>
                <img
                  className="add-sepa-logo"
                  src="/images/trustLogos.png"
                  alt="add-sepa-logo"
                />
              </div>
            </>
          )}
        </div>
        {isLocalizeAdded(localize, 'select.bank.faq') && (
          <div className="faq">
            <Markdown rehypePlugins={[rehypeRaw]}>
              {localize('select.bank.faq')}
            </Markdown>
          </div>
        )}
        <div className="screen-vertical-space" />
      </div>
    </div>
  );
};

export default SelectBankView;
